import React from "react";
import { useFela, CssFelaStyle } from "react-fela";

import { Icon, StyledIconWrapper } from "@/components/Icon";
import { useTheme } from "@/hooks/useTheme";

type IProps = { text: string; customStyle?: CssFelaStyle<unknown, unknown> };

export const ErrorMessage: React.FC<IProps> = ({ text, customStyle = {} }) => {
  const { colors } = useTheme();
  const { css } = useFela();

  return (
    <span
      className={css(
        {
          display: "flex",
          flexDirection: "row",
          fontSize: 12,
          lineHeight: "16px",
          marginTop: 2,
          fontWeight: 600,
          color: colors.RED,
        },
        customStyle,
      )}
    >
      <StyledIconWrapper
        wrapperStyle={{
          display: "inline-flex",
          justifyContent: "flex-start",
          height: 15,
          marginRight: -10,
        }}
        customStyle={{
          transform: "scale(0.5) translate(-15px, -14px)",
        }}
      >
        <Icon iconType="WARNING" />
      </StyledIconWrapper>
      {text}
    </span>
  );
};
